export default __webpack_public_path__ + "static/media/ic_eye.3e34cce8.svg";